module.exports = __webpack_public_path__ + "static/media/play-background-2.0b68dd9e.mp3";